<template>
  <section
    class="resume-main"
    :class="{ _rejected: isRejected && !isInvited }"
  >
    <div class="resume-main__head">
      <div class="resume-main__head-row">
        <div
          v-if="(isOwnResume || isModeratorRoute || isPartnerRoute || !vacancy) && !sharedResume"
          class="resume-main__title  _large"
        >
          {{ $tResumePage('Resume') }}
        </div>
        <div
          v-else
          class="resume-main__title"
        >
          {{ $tResumePage('Candidate on vacancy') }}
          <router-link-modified
            class="resume-main__title-name"
            :to="{name: 'vacancy', params: {vacancyId: $get(vacancy, 'slug')}}"
          >
            {{ $get(vacancy, '[1].name') }}
          </router-link-modified>
        </div>

        <div v-if="isEmployer || sharedResume" class="resume-main__resume-matching">
          <div class="resume-main__resume-matching-title">{{ $tResumePage('Job ratio') }}</div>

          <ResumeConformityProgressMenu :match-data="resumeMatchingData" bottom moved-left>
            <template v-slot:activator>
              <ResumeConformityProgress class="d-flex" :value="resumeMatching" />
            </template>
          </ResumeConformityProgressMenu>
        </div>
      </div>

      <div v-if="!isOwnResume && $get(responseData, 'response_date')" class="resume-main__head-row">
        <div class="resume-main__title">
          {{ $tResumePage('Received') }}
          <span class="resume-main__title-received">{{ $get(responseData, 'response_date') }}</span>
        </div>
      </div>

      <div v-if="isModerator" class="resume-main__head-row mt-2 mb-1">
        <div class="full-width">
          <div class="resume-main__note-title mb-2">
            <BaseSvg
              name="ico-file-pencil-rounded"
              width="2rem"
              height="1.7rem"
            />
            <span class="ml-1">{{ $tResumePage('Global note') }}</span>
          </div>
          <ResumeMainNote
            class="resume-main__note"
            :resume-id="resumeId"
            :note="globalNote"
            @update="$emit('update-note', $event)"
          />
        </div>
      </div>

      <div class="resume-main__head-row">
        <div
          v-if="$get(responseData, 'resume.tags') && (isEmployer || isModerator)"
          class="resume-main__resume-tags"
        >
          <TagsSelector
            :value="$get(responseData, 'resume.tags')"
            :sent-resume-id="sentResumeId"
            @create-tag="createOneResumeTag"
            @input="updateResumeTags"
          />
        </div>

        <div class="d-flex items-center">
          <button
            class="base-btn base-btn--small mr-3"
            @click.prevent="downloadResume({ sent_resume_id: sentResumeId, filename: resumeFilename })"
          >
            <BaseSvg name="ico-download" width="1.5rem" height="1.5rem" />
          </button>

          <div v-if="isEmployer && !sharedResume" class="resume-main__phones-showed pt-2 pb-2">
            <div>
              <BaseSvg name="ico-eye-eyelashes" height="1.5rem" width="1.8rem" />
              <span>
            <span class="account-vacancies-responses__description-text">{{ $tMyResponses('Shown phones') }}: </span>
            <span class="ml-1">{{ phonesStats.shown }}</span>
          </span>
            </div>
            <div>
              <BaseSvg name="ico-eye-eyelashes-hide" height="1.1rem" width="1.8rem" />
              <span>
            <span class="account-vacancies-responses__description-text">{{ $tMyResponses('Available more') }}: </span>
            <span class="ml-1">{{ phonesStats.available }}</span>
          </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="!isEmployee" class="resume-main__inner">
      <div class="resume-main__inner-top">
        <div class="resume-main__main">
          <div>
            <div
              v-if="xsOnly && responseData.is_re_send"
              class="resume-main__re-response-alert mb-2"
            >
              {{ $tResumePage('repeated_response') }}
            </div>

            <div class="d-flex items-center">
              <BaseMenu
                v-if="(isOurEmployer || isModerator) && $get(responseData, 'resume.additional_marks.is_a')"
                :card-style="{ transform: 'translate(-10%, -100%)', padding: '2rem', width: '28rem' }"
              >
                <template v-slot:activator="{ on }">
                  <BaseAvatar
                    :placeholder-name="responseData.resume.additional_marks.is_a ? 'A' : null"
                    size="3.2"
                    font-size="1.6"
                    :color="responseData.resume.additional_marks.is_a ? '#0175ed' : 'transparent'"
                    class="mr-3 cursor-pointer"
                    v-on="on"
                  />
                </template>

                <div class="resume-main__employee-menu">
                  <div><span>{{ $tMyResponses('Agent') }}</span> ID {{ $get(responseData, 'resume.additional_marks.agent_info.agent.id') }}</div>
                  <div v-if="$get(responseData, 'resume.additional_marks.agent_info.agent.fullname')">
                    {{ responseData.resume.additional_marks.agent_info.agent.fullname }}
                  </div>
                  <div v-if="$get(responseData, 'resume.additional_marks.agent_info.agent.phone')">
                    {{ formatPhone(responseData.resume.additional_marks.agent_info.agent.phone) }}
                  </div>
                  <div
                    v-if="$get(responseData, 'resume.additional_marks.agent_info.foreman')"
                    class="resume-main__employee-menu-inset-block"
                  >
                    <div><span>{{ $tMyResponses('Foreman') }}</span> ID {{ $get(responseData, 'resume.additional_marks.agent_info.foreman.id') }}</div>
                    <div v-if="$get(responseData, 'resume.additional_marks.agent_info.foreman.fullname')">
                      {{ responseData.resume.additional_marks.agent_info.foreman.fullname }}
                    </div>
                    <div v-if="$get(responseData, 'resume.additional_marks.agent_info.foreman.phone')">
                      {{ formatPhone(responseData.resume.additional_marks.agent_info.foreman.phone) }}
                    </div>
                  </div>
                </div>
              </BaseMenu>

              <div class="resume-main__main-photowrapper">
                <img
                  v-if="avatar && avatar.answer"
                  class="resume-main__photo"
                  :src="avatar.answer"
                  alt="avatar"
                />
                <div v-else
                     class="resume-main__photo _placeholder">
                  {{ avatarLettersPlaceholder }}
                </div>
              </div>
            </div>
          </div>

          <div class="resume-main__about">
            <div
              v-if="!xsOnly && responseData.is_re_send"
              class="resume-main__re-response-alert mb-2"
            >
              {{ $tResumePage('repeated_response') }}
            </div>

            <div class="resume-main__about-fullname">
              {{ $get(data.items, '[0].answer') }} <br/>
              {{ $get(data.items, '[1].answer') }}
            </div>
          </div>
        </div>
        <div
          v-if="age || ($get(data, 'user_phone') && !sharedResume) || $get(data.items, '[3].answer') || $get(data.items, '[4].answer')"
          class="resume-main__info-list-wrap"
        >
          <div class="resume-main__info-list">
            <div v-if="age" class="resume-main__info-list-item">
              <div class="resume-main__info-list-title">{{ $tResumePage('Birthday') }}</div>
              <div class="resume-main__info-list-subtitle">{{ $get(data.items, '[2].answer') }}
                <span class="resume-main__info-list-subtitle-sub-item">({{ age }}
                  {{ $tResumePage('years old', age) }})</span>
              </div>
            </div>
            <div class="resume-main__info-list-item" v-if="$get(data, 'user_phone') && !sharedResume">
              <div class="resume-main__info-list-title">{{ $tResumePage('Contact phone') }}</div>
              <div v-if="isOpenPhone" class="resume-main__info-list-subtitle">{{ $get(data, 'user_phone') }}</div>
              <button
                v-else
                class="base-btn base-btn--outline-dark base-btn--x-small"
                style="margin-bottom: -1rem;"
                @click="openPhoneDialog"
              >
                {{ $tMyResponses('Show phone') }}
              </button>
            </div>
            <div v-if="$get(data.items, '[3].answer')" class="resume-main__info-list-item">
              <div class="resume-main__info-list-title">{{ $tResumePage('Gender') }}</div>
              <div class="resume-main__info-list-subtitle">{{ $get(data.items, '[3].answer') }}</div>
            </div>
            <div v-if="$get(data.items, '[4].answer')" class="resume-main__info-list-item">
              <div class="resume-main__info-list-title">{{ $tResumePage('Nationality') }}</div>
              <div class="resume-main__info-list-subtitle">{{ $get(data.items, '[4].answer') }}</div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="(!isOwnResume && !isModeratorRoute && !isPartnerRoute && isEmployer && !isModerator) || sharedResume"
           class="resume-main__actions  d-sm-none">
        <ResumeAcceptBtn :isInvited="isInvited"
                         :isRejected="isRejected"
                         :hasInteraction="hasInteraction"
                         :hasInteractionFromAnotherEmployer="hasInteractionFromAnotherEmployer"
                         :responseData="responseData"
                         @accept="$emit('accept')"
                         class="resume-main__btn"/>
        <button v-if="!isRejected || isInvited"
                class="resume-main__btn base-btn base-btn--outline-orange"
                type="button"
                @click="$emit('decline')"
        >
          <span class="base-btn__text">{{ $tResumePage("Deny") }}</span>
          <BaseSvg name="ico-close" width="1.1rem" height="1.1rem"/>
        </button>
      </div>

      <div
        v-if="showConfirmBtn"
        class="resume-main__actions justify-center"
      >
        <ConfirmResumeBtn
          class="resume-main__btn"
          @confirm="responseData.resume.need_accept = false"
        />
      </div>
    </div>

    <div
      v-if="!isOwnResume && !isModeratorRoute && !isPartnerRoute && ($get(responseData, 'invite_send_date') || $get(responseData, 'invite_accept_date')) && !sharedResume"
      class="resume-main__actual  d-sm-none">
      <div :class="['resume-main__actual-item',
        {
          '_dot': $get(responseData, 'invite_accept_date'),
        }
      ]" v-if="$get(responseData, 'invite_send_date')">
        <span>{{ $tResumePage('Invite sent') }}</span>
        <span class="resume-main__actual-item-text">{{
            $get(responseData, 'invite_send_date') | formatDate(true)
          }}</span>
      </div>
      <div class="resume-main__actual-item" v-if="$get(responseData, 'invite_accept_date')">
        <span>{{ $tResumePage('Invite received') }}</span>
        <span class="resume-main__actual-item-text">{{
            $get(responseData, 'invite_accept_date') | formatDate(true)
          }}</span>
      </div>
    </div>
  </section>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex';
  import formatPhone from '../../helpers/formatPhone';
  import windowSizeMixin from '../../mixins/windowSizeMixin';
  import ResumeAcceptBtn from './ResumeAcceptBtn'
  import ConfirmResumeBtn from './ConfirmResumeBtn';
  import ResumeMainNote from './ResumeMainNote';
  import ResumeConformityProgress from '../resume-helpers/ResumeConformityProgress';
  import ResumeConformityProgressMenu from '../resume-helpers/ResumeConformityProgressMenu';

  export default {
    name: "ResumeMain",
    components: {
      ResumeConformityProgressMenu,
      ResumeAcceptBtn,
      ConfirmResumeBtn,
      ResumeMainNote,
      ResumeConformityProgress,
    },
    mixins: [windowSizeMixin],
    props: {
      responseData: {
        type: Object,
        default: () => ({}),
      },
      data: {
        type: [Object, Array],
        default: () => {
        },
      },
      vacancy: {
        type: Object,
        default: () => ({}),
      },
      isInvited: {
        type: Boolean,
        default: false,
      },
      hasInteraction: {
        type: Boolean,
        default: false,
      },
      hasInteractionFromAnotherEmployer: {
        type: Boolean,
        default: false,
      },
      isOwnResume: {
        type: Boolean
      },
      isRejected: {
        type: Boolean
      },
      isModeratorRoute: {
        type: Boolean
      },
      isPartnerRoute: {
        type: Boolean
      },
      sharedResume: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        phonesStats: {
          shown: '-',
          available: '-',
        },
        allTags: [],
      };
    },
    computed: {
      ...mapGetters('user', [
        'isEmployee',
        'isEmployer',
        'isModerator',
        'isPartner',
        'isAgent',
        'isOurEmployer',
      ]),

      resumeId() {
        return this.$get(this.responseData, 'resume.resume_id');
      },
      sentResumeId() {
        return this.$route.params.resumeId;
      },
      resumeMatching() {
        return this.$get(this.responseData, 'resume.additional_marks.match') || 0;
      },
      resumeMatchingData() {
        return this.$get(this.responseData, 'resume.additional_marks.match_array') || {};
      },
      isOpenPhone() {
        return this.$get(this.responseData, 'resume.open_phone');
      },

      age() {
        if ((this.$get(this.data, 'items[2].answer'))) {
          const currentTime = new Date().getTime();
          const birthdayTime = new Date(this.$get(this.data, 'items[2].answer')).getTime();

          return Math.floor((currentTime - birthdayTime) / 31536000000);
        }

        return null;
      },
      avatarLettersPlaceholder() {
        return (this.$get(this.data, 'items[0].answer') || '').charAt(0) + (this.$get(this.data, 'items[1].answer') || '').charAt(0);
      },
      avatar() {
        return this.data.items.find(item => item.question_id === 'avatar')
      },
      globalNote() {
        return this.$get(this.responseData, 'resume.global_note');
      },
      showConfirmBtn() {
        return this.$get(this.responseData, 'resume.need_accept') && !this.isOwnResume && !this.sharedResume && (this.isPartner || this.isAgent);
      },
      resumeFilename() {
        return `${this.$get(this.responseData, 'resume[1].name')}_${this.$get(this.responseData, 'resume[1].surname')}`;
      },
    },
    created() {
      this.loadPhonesStats();
    },
    methods: {
      ...mapActions('helpers', [
        'canDoAction',
      ]),
      ...mapActions('resume', [
        'downloadResume',
      ]),
      ...mapActions('vacancies/responses', [
        'setResumeMark',
        'openResumePhone',
        'createResumeTag',
        'saveResumeTags',
        'getPhonesStats',
      ]),

      formatPhone,

      loadPhonesStats() {
        this.getPhonesStats()
          .then(({ phone_views, phone_remaining }) => {
            this.phonesStats = { shown: phone_views, available: phone_remaining };
          })
          .catch(() => {});
      },

      async createOneResumeTag(tag, onSuccess) {
        const updatedTags = await this.createResumeTag({ tag, sent_resume_id: this.sentResumeId });
        if (updatedTags) {
          this.$set(this.responseData.resume, 'tags', updatedTags);
          const newTag = this.responseData.resume.tags.find(t => t.name === tag.name);
          if (onSuccess) onSuccess(newTag);
        }
      },
      async updateResumeTags(tags) {
        const statusOrTags = await this.saveResumeTags({ tags, sent_resume_id: this.sentResumeId });
        if (Array.isArray(statusOrTags)) {
          this.$set(this.responseData.resume, 'tags', statusOrTags);
        } else if (statusOrTags) {
          this.$set(this.responseData.resume, 'tags', tags);
        }
      },
      async openPhoneDialog() {
        const canSave = await this.canDoAction({ action: 'action_open_phones' });
        this.$vModal.open('confirm', {
          title: canSave.popup?.title || this.$tMyResponses('Show phone'),
          message: canSave.popup?.text || this.$tMyResponses('Want to open phone number'),
          successBtnClass: 'base-btn--outline-blue',
          onSuccess: () => {
            this.openPhone();
          },
        });
      },
      openPhone() {
        const success = this.openResumePhone({ sent_resume_id: this.sentResumeId });
        if (success) {
          this.responseData.resume.open_phone = true;
          this.phonesStats.shown++;
          this.phonesStats.available--;
        }
      },
    },
  };
</script>

<style lang="less"></style>
